import { CampaignState } from './campaigns';
import { LeadState } from './leads';
import { TemplateState } from './templates';
import { UsersListState } from './users';

export * from './campaigns';
export * from './leads';
export * from './users';
export * from './templates';


export const AppState = [
    CampaignState,
    LeadState,
    UsersListState,
    TemplateState
]